// css
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/reset.scss'
import './assets/css/transition.scss'

import Vue from 'vue'
import ElementUI from 'element-ui'
import store from './store'
import router from './router'
import App from './App.vue'
import xss from 'xss'
import echarts from 'echarts'
import constants from './util/constants'
import Loading from './components/loading/loading'

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.prototype.$echarts = echarts

Vue.component('Loading', Loading)
Vue.prototype.$constants = constants
Vue.prototype.$xss = xss
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
